import React, { Component } from 'react';
import { Grid, Header, Segment, Container } from 'semantic-ui-react';

const sfbridge=require('../../img/sfbridge.svg');
//import '../css/404.css';

class Story extends Component {
  render() {
    return(
      <Segment vertical
        style={{
            padding: '8em 0em',
            backgroundImage: `url(${ sfbridge })`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right center',
            overflow: 'hidden',
            height: 'auto'
          }}
        >
        <Container>
          <Grid>
            <Grid.Row>
              <Header as='h3' style={{ fontSize: '2.5em', fontFamiy: 'Raleway', fontFamily: 'serif'}}> Our Mission. </Header>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column computer={10} tablet={11} mobile={14}>
                <p style={{fontFamily: 'Montserrat', lineHeight: '26px', fontSize: '16px', fontWeight:'bold'}}>
                    At BeemaBroker we are passionate about millennials starting their
                    own businesses and making an impact in their communities! Starting
                    a business can be a tedious and challenging process especially with
                    trying to figure out where to get business insurance quotes. With
                    our CEO’s past 9 years of insurance experience, BeemaBroker has
                    created a secure web application that gives business owners the
                    power of information at their fingertips. We’ve sifted out the
                    unnecessary parts of the song and dance brokers go through while
                    providing a simple quote and servicing a policy. By providing an
                    on demand experience we aim to make the process more enjoyable.
                    Our goal is to add value and time back into your day so you can
                    focus your energy on growing your business!
                  </p>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
      </Segment>
    );
  }
}

export default Story;



// WEBPACK FOOTER //
// ./src/js/About/Story.js